<script lang="ts" setup>
// compiler macro
definePageMeta({ layout: "page" });
useHead({ title: "企业新闻" });

// 模拟新闻数据
const newsItems = ref([
  {
    id: 1,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "", // 占位
  },
  {
    id: 2,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "",
  },
  {
    id: 3,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "",
  },
  {
    id: 4,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "",
  },
  {
    id: 5,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "",
  },
  {
    id: 6,
    title: "公司完成新一轮融资，加速技术创新...",
    description:
      "这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里新闻内容这里...",
    date: "2025-02-23",
    image: "",
  },
]);

const currentPage = ref(1);
const totalPages = ref(50);
</script>

<template>
  <div class="min-h-screen w-full bg-[#F9FBFF] m-auto">
    <!-- 顶部横幅图片 -->
    <div class="w-full h-[300px] bg-gray-300">
      <!-- 占位图片 -->
    </div>

    <!-- 新闻列表容器 -->
    <div class="max-w-screen-xl mx-auto px-6 py-12">
      <!-- 新闻卡片网格 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-5">
        <NuxtLink
          v-for="item in newsItems"
          :key="item.id"
          :to="`/news/${item.id}`"
          class="bg-white rounded-md overflow-hidden transition-shadow duration-300 news-card"
        >
          <!-- 卡片图片 -->
          <div class="w-full h-[200px] bg-gray-200">
            <!-- 占位图片 -->
          </div>

          <!-- 卡片内容 -->
          <div class="py-5 px-6">
            <!-- 标题 -->
            <p class="text-xl font-black text-black mb-2 line-clamp-1">
              {{ item.title }}
            </p>

            <!-- 描述 -->
            <p
              class="text-base text-[#4B5563] text-normal mb-3 line-clamp-3 leading-6"
            >
              {{ item.description }}
            </p>

            <!-- 底部：日期和查看详情 -->
            <div class="flex items-center justify-between text-sm">
              <span class="text-sm text-normal text-black">
                {{ item.date }}
              </span>
              <span class="font-medium gradient-text"> 查看详情 </span>
            </div>
          </div>
        </NuxtLink>
      </div>

      <!-- 分页 -->
      <div class="flex justify-center">
        <UPagination
          v-model="currentPage"
          :total="totalPages"
          :page-count="10"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.gradient-text {
  background: linear-gradient(90deg, #36ba93 0%, #47c3e1 50%, #073c89 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>
